import React from "react";
import "./Services.css";
import { NavLink } from "react-router-dom";
import {
  FiHexagon,
  FiBox,
  FiCommand,
  FiActivity,
  FiShield,
  FiPieChart,
} from "react-icons/fi";

const services = [
  {
    id: "01",
    icon: <FiHexagon />,
    title: "Web3 Ecosystems",
    desc: "Architecting decentralized futures with high-performance protocols and scalable dApps.",
    url: "/blockChain",
  },
  {
    id: "02",
    icon: <FiBox />,
    title: "Game Engineering",
    desc: "Pushing the boundaries of immersion with enterprise-grade 2D/3D development.",
    url: "/game",
  },
  {
    id: "03",
    icon: <FiCommand />,
    title: "Mobile Innovation",
    desc: "Building the next generation of intuitive, high-velocity native and hybrid mobile apps.",
    url: "/mobileapp",
  },
  {
    id: "04",
    icon: <FiActivity />,
    title: "Enterprise Systems",
    desc: "Modernizing corporate infrastructure with high-availability cloud-native architectures.",
    url: "/webdevelopment",
  },
  {
    id: "05",
    icon: <FiPieChart />,
    title: "Growth Strategy",
    desc: "Harnessing data science and neural marketing to accelerate global visibility.",
    url: "/marketing",
  },
  {
    id: "06",
    icon: <FiShield />,
    title: "Design Systems",
    desc: "Crafting bulletproof UI/UX frameworks that define brand identities in 2026.",
    url: "/graphic",
  },
];

const Services = () => {
  return (
    <section className="clean-services-2026" id="services">
      <div className="services-container-v2">
        <div className="section-header-left">
          <div className="section-badge-small">Our Capabilities</div>
          <h2 className="section-title-refined">
            Engineering the <span className="blue-accent">Digital Future</span>
          </h2>
          <p className="section-subtitle-refined">
            We deliver high-impact digital products through technical precision
            and creative mastery.
          </p>
        </div>

        <div className="clean-grid-2026">
          {services.map((service) => (
            <NavLink
              to={service.url}
              key={service.id}
              className="clean-card-2026"
            >
              <div className="card-index-dot">{service.id}</div>
              <div className="card-icon-refined">{service.icon}</div>
              <div className="card-content-refined">
                <h3>{service.title}</h3>
                <p>{service.desc}</p>
              </div>
              <div className="card-action-refined">
                <span>Explore</span>
                <FiCommand className="explore-spin" />
              </div>
            </NavLink>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
